import { useEffect, useRef, useState } from 'react';
import useLogout from '../hooks/useLogout';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
// import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import Cookies from "js-cookie";
import AnimatedClock from './AnimatedClock';


const INACTIVITY_LIMIT = 30 * 60 * 1000;

const events = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart',
  'click',
];

export default function AutoSignOut() {
  const logout = useLogout();
  const timerRef = useRef(null);
  const warningRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const isLoggedIn = !!Cookies.get("authToken");

    useEffect(() => {
    if (!isLoggedIn) {
      setShowWarning(false);
      setCountdown(60);
      if (timerRef.current) clearTimeout(timerRef.current);
      if (warningRef.current) clearInterval(warningRef.current);
      return; 
    }

      resetTimer();
      events.forEach((event) => window.addEventListener(event, resetTimer));

      return () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        if (warningRef.current) clearInterval(warningRef.current);
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
      };


  }, [isLoggedIn]);

    if (!isLoggedIn) return null;


  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);

    setShowWarning(false);
    setCountdown(60);

    timerRef.current = setTimeout(() => {
      setShowWarning(true);

      let count = 60;
      setCountdown(count);
      warningRef.current = setInterval(() => {
        count--;
        setCountdown(count);
        if (count <= 0) {
          clearInterval(warningRef.current);
          logout();
        }
      }, 1000);
    }, INACTIVITY_LIMIT);
  };

  const handleStayLoggedIn = () => {
    resetTimer();
  };

  return (
    <Dialog open={showWarning} PaperProps={{ sx: { borderRadius: 4, p: 2 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: 2,
        }}
      >
        {/* <AccessTimeOutlinedIcon
          sx={{ fontSize: 54, color: '#0154D2', mb: 2 }}
        /> */}

        <AnimatedClock seconds={countdown} />
        <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center', pb: 0 }}>
          Are you still there?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: 'center', color: '#222', mb: 1 }}>
            You’ve been inactive for a while.
            <br />
            For your security, you’ll be signed out in <b>{countdown}</b>{' '}
            seconds.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ flexDirection: 'column', gap: 1, width: '100%' }}>
          <Button
            onClick={handleStayLoggedIn}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: '#0154D2',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 16,
              borderRadius: 2,
              '&:hover': { bgcolor: '#02296C' },
            }}
          >
            Stay Logged In
          </Button>
          <Button
            onClick={logout}
            variant="outlined"
            fullWidth
            sx={{
              mt: 1,
              borderColor: '#0154D2',
              color: '#0154D2',
              fontWeight: 500,
              borderRadius: 2,
              '&:hover': { borderColor: '#02296C', color: '#02296C' },
            }}
          >
            Sign Out Now
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
